import { useEffect } from 'react';

// Nested modals must not each restore the body style: only the last one does.
let lockCount = 0;
let previousOverflow = '';

/**
 * Prevents the page behind an overlay from scrolling while it is open.
 *
 * @param {boolean} active - Whether the lock is applied (default: true)
 */
function useBodyScrollLock(active = true) {
    useEffect(() => {
        if (!active || typeof document === 'undefined') return undefined;

        if (lockCount === 0) {
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        lockCount += 1;

        return () => {
            lockCount -= 1;
            if (lockCount === 0) {
                document.body.style.overflow = previousOverflow;
            }
        };
    }, [active]);
}

export default useBodyScrollLock;
